export default "__VITE_ASSET__97b6023b__"